import script from "./AdminTrainingDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTrainingDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminTrainingDashboardView.vue?vue&type=style&index=0&id=4ebc26d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ebc26d6"]])

export default __exports__